module.exports = __webpack_public_path__ + "static/media/DONT SHOOT FILMS 3.bc1ad29d.png";